var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAssignedHorizontal = function SvgAssignedHorizontal(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "assigned_horizontal_svg__a",
    width: 18,
    height: 18,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h17.454v17.454H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#assigned_horizontal_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.12 12.028a3.18 3.18 0 0 1-2.336-.965 3.18 3.18 0 0 1-.966-2.335q0-1.37.966-2.335a3.18 3.18 0 0 1 2.335-.966h2.196q.232 0 .388.157a.53.53 0 0 1 .157.389.53.53 0 0 1-.157.388.53.53 0 0 1-.388.157H5.118q-.914 0-1.562.647a2.13 2.13 0 0 0-.647 1.562q0 .916.647 1.563.647.648 1.562.647h2.197q.232 0 .388.157a.53.53 0 0 1 .157.389.53.53 0 0 1-.157.388.53.53 0 0 1-.388.157zm1.426-2.755a.53.53 0 0 1-.389-.157A.53.53 0 0 1 6 8.727q0-.232.157-.388a.53.53 0 0 1 .389-.157h4.363q.232 0 .389.157a.53.53 0 0 1 .157.389.53.53 0 0 1-.157.388.53.53 0 0 1-.389.157zm3.594 2.755a.53.53 0 0 1-.389-.157.53.53 0 0 1-.156-.389q0-.232.156-.388a.53.53 0 0 1 .389-.157h2.197q.914 0 1.562-.647a2.13 2.13 0 0 0 .647-1.563 2.13 2.13 0 0 0-.647-1.562 2.13 2.13 0 0 0-1.562-.647H10.14a.53.53 0 0 1-.389-.157.53.53 0 0 1-.156-.389q0-.232.156-.389a.53.53 0 0 1 .389-.156h2.196q1.37 0 2.335.965a3.18 3.18 0 0 1 .966 2.335q0 1.37-.966 2.335a3.18 3.18 0 0 1-2.335.966z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAssignedHorizontal);
export default ForwardRef;